import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';
import useMediaQuery from '../hooks/useMediaQuery';

// Wraps an interactive element so it eases toward the cursor on hover.
// Passthrough on touch devices and under reduced motion.
const Magnetic = ({ children, strength = 0.3, className }) => {
  const ref = useRef(null);
  const finePointer = useMediaQuery('(pointer: fine)');
  const reducedMotion = useReducedMotion();
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 15, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 200, damping: 15, mass: 0.4 });

  if (!finePointer || reducedMotion) {
    return className ? <span className={className}>{children}</span> : children;
  }

  const onPointerMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - (rect.left + rect.width / 2)) * strength);
    y.set((e.clientY - (rect.top + rect.height / 2)) * strength);
  };

  const onPointerLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.span
      ref={ref}
      className={className}
      style={{ x: sx, y: sy, display: 'inline-block' }}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
    >
      {children}
    </motion.span>
  );
};

export default Magnetic;
